import axios from 'axios'
import CreateUniversity from './dto/CreateUniversity'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedUniversityResultRequestDto} from './dto/PagedUniversityResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllUniversities from './dto/GetAllUniversities'
import UpdateUniversity from './dto/UpdateUniversity'
import GetUniversity from './dto/GetUniversity'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/University/Create`
export const URL_DELETE = `${API_URL}/University/Delete`
export const URL_GET = `${API_URL}/University/Get`
export const URL_GET_ALL = `${API_URL}/University/GetPagedAll`
export const URL_UPDATE = `${API_URL}/University/Update`

export function onCreateUniversity(createUniversity: CreateUniversity): Promise<boolean> {
  return axios.post(URL_CREATE, createUniversity)
}

export function onDeleteUniversity(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetUniversity(entityDto: EntityDto): Promise<GetUniversity> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllUniversities(
  pagedFilterAndSortedRequest: PagedUniversityResultRequestDto
): Promise<PagedResultDto<GetAllUniversities>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateUniversity(updateUniversityInput: UpdateUniversity): Promise<boolean> {
  return axios.put(URL_UPDATE, updateUniversityInput)
}
